<div class="layout-content" style="margin-top:20px;">
   <div class="grid">
      <div class="col-12 flex justify-content-center">
         <p-table [value]="rows" [reorderableColumns]="false" (onRowReorder)="rowReorder($event)">
            <ng-template pTemplate="header" let-columns>
               <tr>
                  <th style="width:3rem"></th>
                  <th><div class="flex align-items-center justify-content-center">{{ 'REORDER_ROWS' | translate }}</div></th>
               </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row let-columns="columns" let-index="rowIndex">
               <tr [pReorderableRow]="index">
                  <td>
                      <span class="pi cm-bars" pReorderableRowHandle></span>
                  </td>
                  <td>{{ (row.ContentType === 'text') ? (( row.ContentIt.length > 150 ) ? ( row.ContentIt | slice:0:150 ) + '..' : ( row.ContentIt )) : (( row.ContentType === 'video' ) ? '[VIDEO]' : '[IMAGE]') }}</td>
               </tr>
            </ng-template>
         </p-table>
      </div>
   </div>

   <div class="grid mt-8 mb-1 mx-1 flex justify-content-center align-items-center">
      <button type="button" pButton pRipple (click)="closeDialog()" label="{{ 'CLOSE' | translate }}" class="p-button-secondary text-xl font-normal mt-3 sm:mt-0 ml-0 sm:ml-1" [ngClass]="dynamicButtonWidth()">
      </button>
   </div>
</div>